export default () => ({
	form: '',

	selectCountry(code) {
		this.form = this.$el.closest('form');

		const country_code = this.form.querySelector('.location-selector-country-code');
		const language = this.form.querySelector('.location-selector-language-code');

		country_code.value = code;

		if (code === 'DE') {
			language.value = 'de';
		} else {
			language.value = 'en';
		}

		this.form.submit();
	},
});
